import axios from "axios";

const API_URL = process.env.REACT_APP_HOST_API;

class UsuarioService {
    
    async getAll() {
        var url = `${API_URL}/v1/usuario`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getById(id) {
        var url = `${API_URL}/v1/usuario/${id}`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getAgenda() {
        var url = `${API_URL}/v1/usuario/agenda`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async getAllResumo() {
        var url = `${API_URL}/v1/usuario/resumo`;
        return axios.get(url, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async save(user) {
        var url = `${API_URL}/v1/usuario`;
        return axios.post(url, user, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }

    async changePassword(passwordData) {
        var url = `${API_URL}/v1/usuario/alterar-senha`;
        return axios.post(url, passwordData, {
            headers: {
                authorization: "Bearer " + localStorage.getItem("authorizationWGSolJwtToken"),
            },
        });
    }
}

export default new UsuarioService();
